// extracted by mini-css-extract-plugin
export default {"cls1":"PaperNewsStory-cls1_p8w","cls2":"PaperNewsStory-cls2_JNE PaperNewsStory-cls1_p8w","variant-dense":"PaperNewsStory-variant-dense_FSX"};